export default "__VITE_ASSET__ouWuYiAd__"